/**
 * @Author: liuchen
 * @Date:   2018-03-23T14:19:53+08:00
 * @Email:  zhangyugegeliuchen@didichuxing.com
 * @Filename: bd.js
 * @Last modified by:   liuchen
 * @Last modified time: Tue Nov 20 2018 18:23:12 GMT+0800
 * 共bd去做演示的路由
 */
const ProcessShow = {
  path: '/mock/processshow',
  name: 'processshow',
  meta: {
    title: 'Mock'
  },
  component (resolve) {
    require.ensure([], () => resolve(require('../page/bd/processShow/index')))
  }
}
const ProcessLogin = {
  path: '/mock/processlogin',
  name: 'processlogin',
  meta: {
    title: 'Mock'
  },
  component (resolve) {
    require.ensure([], () => resolve(require('../page/bd/processShow/login')))
  }
}
export default [ProcessShow, ProcessLogin]
